module.exports = __webpack_public_path__ + "static/img/bg_h_pic.0290808a.png";